export enum Actions {
    "ToggleDranging",
    "InfoDranging",
    "SetListDeleted",
}